/* eslint-disable @typescript-eslint/naming-convention */

import JTableCell from '@atoms/JTabelCell';
import {
  CreditTopUp,
  CreditsSharing,
} from '@enterprise/models/get-credit-topup';
import { formatDate } from '@lib/dateUtils';
import { TableRowStyled } from '@styled/table-row.styled';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

interface Props {
  row: CreditTopUp;
}

const RechargeTableRow = ({ row }: Props) => {
  const { id, createdAt, eurosAmount, creditsAmount, creditsSharing } = row;
  const { t } = useTranslation();
  return (
    <TableRowStyled key={id} data-test={`recharge-list-row-${id}`}>
      <JTableCell>{formatDate(createdAt)}</JTableCell>
      <JTableCell>{`${eurosAmount} €`}</JTableCell>
      <JTableCell>{creditsAmount}</JTableCell>
      <JTableCell>{creditsSharing.length > 0 ? t('YES') : t('NO')}</JTableCell>
      <JTableCell>
        {creditsSharing.map((e: CreditsSharing, index) => (
          <Stack key={index}>
            <Typography>
              {creditsSharing.length > 0
                ? `${e.establishment.name}
                (${e.creditsAmount} coins)`
                : `0`}
            </Typography>
          </Stack>
        ))}
      </JTableCell>
    </TableRowStyled>
  );
};

export default RechargeTableRow;
